export const isOdd = (n: number): boolean => n % 2 !== 0;

export const decimals = (n: number | undefined | null, length = 4): string => {
	if (n === undefined || n === null) {
		return '-';
	}

	if (!Number.isFinite(n)) {
		return '-';
	}
	return n.toFixed(length);
};
